import { combineReducers } from 'redux';
import UIReducers from './ui';
import UserReducer from './user';
import FormReducer from './form';
import AdminReducer from './admin';


const rootReducers = history => combineReducers({
  ui: UIReducers,
  user: UserReducer,
  form: FormReducer,
  admin: AdminReducer,
});

export default rootReducers;
